/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select } from 'antd';

const SortDataForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={{ direction: 'asc', ...config }} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="Sort By Column" name="column" rules={[{ required: true }]}>
            <Select placeholder="Select column" options={columns.map(c => ({ label: c, value: c }))} />
        </Form.Item>
        <Form.Item label="Sort Direction" name="direction" rules={[{ required: true }]}>
            <Select options={[
                { label: 'Ascending (A-Z, 0-9)', value: 'asc' },
                { label: 'Descending (Z-A, 9-0)', value: 'desc' },
            ]} />
        </Form.Item>
    </Form>
);

export default SortDataForm;
